module.exports = __webpack_public_path__ + "static/media/snow.13bc933b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/weather/snow.png
// module id = 6656
// module chunks = 0